{
  "key": "rosi.symbo.ls",
  "distDir": "./smbls"
}